import HeroWithLogo24 from "./heroWithLogo24";

export default HeroWithLogo24;
